import React, { useContext, useEffect } from "react";
import NewRoadMap from "../components/NewRoadmap";

const RoadmapPage = () => {
  return <NewRoadMap showLoading={false} />;
};

export default RoadmapPage;
